export default __webpack_public_path__ + "static/media/icon-flag-denmark.bb866f00.svg";